import React, { FC, useEffect } from "react";
import { useHistory } from "react-router";

import { useUserManager } from "../../services/auth";
import { useReturnToLocation } from "../../hooks";

export const OidcSignoutCallback: FC = () => {
  const history = useHistory();
  const userManager = useUserManager();
  const { pathname: returnTo } = useReturnToLocation();

  useEffect(() => {
    userManager.signoutRedirectCallback().finally(() => {
      history.replace(returnTo);
    });
  }, [history, userManager, returnTo]);
  return <div />;
};
